import {Component, input, InputSignal} from '@angular/core';
import {ManagerForm} from "../../forms/manager.form";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {NgxMaskDirective} from "ngx-mask";
import {ValidationErrorsComponent} from "../../../../../../../common/validation-errors/validation-errors.component";

@Component({
  selector: 'app-manager-form',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent,
    ReactiveFormsModule
  ],
  templateUrl: './manager-form.component.html'
})
export class ManagerFormComponent {
  public form: InputSignal<ManagerForm | null> = input<ManagerForm | null>(null);
}
